
if (!customElements.get("compare-products")) {
  customElements.define(
    "compare-products",
    class CompareProducts extends HTMLElement {
      connectedCallback() {
        const handleIntersection = (entries, observer) => {
          if (!entries[0].isIntersecting) return;
          observer.unobserve(this);
        };
        new IntersectionObserver(handleIntersection.bind(this), {
          rootMargin: "0px 0px 400px 0px",
        }).observe(this);

        this.loaddata();
      }
      loaddata() {
        const updateActiveStates = () => {
          $('.compare-product-select:not(:checked)').parents('.product-select-tab').removeClass('active');
          $('.compare-product-select:checked').parents('.product-select-tab').addClass('active');
        };

        updateActiveStates();
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', updateActiveStates);
        }
        window.addEventListener('load', updateActiveStates);

        $(this).on('click', '.product-select-tab', function (e) {
          if ($(e.target).is('input, label') || $(e.target).closest('label').length) return;
          if ($(this).attr('disabled') === 'disabled') return;

          const checkbox = $(this).find('.compare-product-select');
          checkbox.prop('checked', !checkbox.prop('checked')).trigger('change');
        });

        $(this).on('change', '.compare-product-select', function () {
          var checkcount = $('.compare-product-select:checked').length;

          if (checkcount > 3) {
            $(this).prop('checked', false);
            return;
          }

          updateActiveStates();

          if (checkcount == 3) {
            $('.compare-product-select:not(:checked)').parents('.product-select-tab').attr('disabled', true);
          } else {
            $('.compare-product-select:not(:checked)').parents('.product-select-tab').attr('disabled', false);
          }

          $('.row-column').addClass('compare-hide');
          $('.compare-product-select:checked').each(function(){
            var pid = $(this).data('pid');
            $('.row-column[data-product="'+pid+'"]').removeClass('compare-hide');
          });

          $('.row-column').removeClass('row-1-col row-2-col row-3-col');
          if (checkcount == 1) {
            $('.row-column').addClass('row-1-col');
          } else if (checkcount == 2) {
            $('.row-column').addClass('row-2-col');
          } else if (checkcount == 3) {
            $('.row-column').addClass('row-3-col');
          }

          $('.select-count').html(`${checkcount}/3 selected`);

          if (checkcount == 0) {
            $('.product-compare-container').hide();
            $('.none-selected').show();
          } else {
            $('.product-compare-container').show();
            $('.none-selected').hide();
          }
        });

      }
    }
  );
}